import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function ForwardIcon(props: SvgIconProps): JSX.Element {
  const defaultColor = "primary";
  const color = props.color || defaultColor;
  return (
      <SvgIcon
          {...props}
          color={color}
          xmlns="http://www.w3.org/2000/svg"
          x={0}
          y={0}
          viewBox="0 0 24 24"
          xmlSpace="preserve"
          enableBackground="new 0 0 24 24"
          titleAccess="Forward">
          <path
              d="M14.97 10.791H5.333C4.6 10.791 4 11.337 4 12.005c0 .667.6 1.214 1.333 1.214h9.637v2.172c0 .546.72.813 1.133.425l3.707-3.386a.584.584 0 0 0 0-.862L16.103 8.18c-.413-.388-1.133-.109-1.133.425v2.185Z"
          />
      </SvgIcon>
  );
}
